"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _has = _interopRequireDefault(require("lodash/has"));
var _reduxThunk = _interopRequireDefault(require("redux-thunk"));
var _intlMiddleware = _interopRequireDefault(require("./intlMiddleware"));
var _analyticsMiddleware = _interopRequireDefault(require("./analyticsMiddleware"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var middlewares = {
  intl: _intlMiddleware.default,
  reduxThunk: _reduxThunk.default,
  analytics: _analyticsMiddleware.default
};

// Provide a function so consumers can override a middleware if they want to
var customize = function customize(mods) {
  return Object.keys(middlewares).map(function (key) {
    if (mods && (0, _has.default)(mods, key)) {
      return mods[key](middlewares[key]);
    }
    return middlewares[key];
  }).filter(function (el) {
    return el;
  });
};
var toArray = function toArray() {
  return customize();
};
var defaultArray = toArray();
defaultArray.customize = customize;

// Export array of middlewares
var _default = exports.default = defaultArray;